module.exports = __webpack_public_path__ + "img/Asset cowok cewek (full badan).0839bedb.svg";